'use client';

import type { ClientLogPayload, LogLevel } from '@/types/log';

async function send(payload: ClientLogPayload): Promise<void> {
	try {
		await fetch('/api/log', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(payload),
			keepalive: true,
		});
	} catch (_err) {
		// Avoid throwing in client; this is best-effort
	}
}

export const clientLogger = {
	log: (message: string, context?: unknown) => send({ level: 'info', message, context }),
	info: (message: string, context?: unknown) => send({ level: 'info', message, context }),
	debug: (message: string, context?: unknown) => send({ level: 'debug', message, context }),
	warn: (message: string, context?: unknown) => send({ level: 'warn', message, context }),
	error: (message: string, context?: unknown) => send({ level: 'error', message, context }),
	custom: (level: LogLevel, message: string, context?: unknown) => send({ level, message, context }),
}; 